import { useCompanyChatAgents } from './useCompanyChatAgents';

/**
 * Fetches all company chat agents.
 * Shares the React Query cache with other company chat agent hooks.
 */
export const useDashboardChatAgents = (enabled = true) => {
  return useCompanyChatAgents(enabled);
};
